import * as React from "react";

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={8.99} height={8.99} {...props}>
    <path
      data-name="Path 306"
      d="M88.5 14a4.5 4.5 0 1 0 4.5 4.5 4.5 4.5 0 0 0-4.5-4.5zm1.94 6.075-.36.36-1.58-1.58-1.58 1.58-.36-.36 1.58-1.58-1.58-1.58.36-.36 1.58 1.58 1.58-1.58.36.36-1.58 1.58z"
      transform="translate(-84 -14)"
      style={{
        fill: "#00446e",
      }}
    />
  </svg>
);

export default SvgComponent;
